import type { IconProps } from "@/types/icon";

const Cross = ({ color = "black", className }: IconProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.57564 2.57573C2.80995 2.34142 3.18985 2.34142 3.42417 2.57573L5.9999 5.15147L8.57564 2.57573C8.80995 2.34142 9.18985 2.34142 9.42417 2.57573C9.65848 2.81004 9.65848 3.18994 9.42417 3.42426L6.84843 5.99999L9.42417 8.57573C9.65848 8.81004 9.65848 9.18994 9.42417 9.42426C9.18985 9.65857 8.80995 9.65857 8.57564 9.42426L5.9999 6.84852L3.42417 9.42426C3.18985 9.65857 2.80995 9.65857 2.57564 9.42426C2.34132 9.18994 2.34132 8.81004 2.57564 8.57573L5.15137 5.99999L2.57564 3.42426C2.34132 3.18994 2.34132 2.81004 2.57564 2.57573Z"
      fill={`hsl(var(--${color}))`}
    />
  </svg>
);

export default Cross;
